export enum FormName {
  BETRIEBSTATTE_FORM = "betriebstatteForm",
  CONTACT_DETAILS_FORM = "contactDetails",
}
